<invoice-provider-state-jname>

    <span>
        { (jnames["JNAME_" + props.invoice_provider_state]) ? jnames["JNAME_" + props.invoice_provider_state] : "不明"}
    </span>


    <script>
        export default {
            jnames: {
                "JNAME_0": "不明",
                "JNAME_1": "不明",
                "JNAME_10": "適格請求書発行事業者以外の者",
                "JNAME_20": "適格請求書発行事業者",
            }
        };
    </script>

</invoice-provider-state-jname>